import {useReposAppPayload} from '@github-ui/code-view-shared/contexts/FilesPageInfoContext'
import {useCurrentRepository} from '@github-ui/current-repository'
import {VerifiedHTMLBox} from '@github-ui/safe-html/VerifiedHTML'
import {CheckIcon, type Icon, InfoIcon, LawIcon, XIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'
import {Octicon} from '@primer/styled-react/deprecated'
import {clsx} from 'clsx'

import {useDeferredMetadata} from '../../../contexts/DeferredMetadataContext'
import styles from './BlobLicenseBanner.module.css'

export function BlobLicenseBanner() {
  const {license} = useDeferredMetadata()
  const repo = useCurrentRepository()
  const {helpUrl} = useReposAppPayload()

  const iconMap: {[group: string]: {icon: Icon; color: string}} = {
    permissions: {icon: CheckIcon, color: 'success.fg'},
    limitations: {icon: XIcon, color: 'danger.fg'},
    conditions: {icon: InfoIcon, color: 'accent.fg'},
  }

  if (!license) return null

  return (
    <div className={styles.Box}>
      <div className={clsx('blob-license-banner-outer', styles.Box_1)}>
        <div className={styles.Box_2}>
          <div className={styles.Box_3}>
            <Octicon icon={LawIcon} size={32} />
            <div className={styles.Box_4}>
              <div className={styles.Box_5}>
                {`${repo.ownerLogin}/${repo.name} is licensed under`}{' '}
                {license.name.toLowerCase().startsWith('the ') ? `` : ` the`}
              </div>
              <h3>{license.name}</h3>
            </div>
          </div>
          <VerifiedHTMLBox html={license.description} className={styles.VerifiedHTMLBox} />
        </div>
        <div className={styles.Box_6}>
          {Object.keys(license.rules).map((group, index) => {
            return (
              // eslint-disable-next-line @eslint-react/no-array-index-key
              <div key={index} className={styles.Box_7}>
                <h5 className={styles.Box_8}>{group.charAt(0).toUpperCase() + group.substring(1)}</h5>
                {license.rules[group]!.map(rule => (
                  <div key={rule.tag} className={styles.Box_9}>
                    <Octicon
                      icon={iconMap[group]!.icon}
                      size={13}
                      sx={{
                        color: iconMap[group]!.color,
                      }}
                      className={styles.Octicon}
                    />
                    {rule.label}
                  </div>
                ))}
              </div>
            )
          })}
        </div>
      </div>
      <div className={styles.Box_10}>
        This is not legal advice.&nbsp;
        <Link inline href={`${helpUrl}/articles/licensing-a-repository/#disclaimer`}>
          Learn more about repository licenses
        </Link>
      </div>
    </div>
  )
}
